import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import Router from './routes/Router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserProvider } from 'contexts/UserProvider';
import Title from 'antd/es/skeleton/Title';
import { TitleProvider } from 'contexts/TitleProvider';
import LoadGoogleMapsScript from 'components/Map/LoadGoogleMapsScript';

// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <TitleProvider>
          <ToastContainer />
          <LoadGoogleMapsScript />
          <Router />
        </TitleProvider>
      </UserProvider>
    </QueryClientProvider>
  );
}

export default App;
